/* 
NOTE: This is not perfect but it works reasonably well to make MW and QTY fit the buttons at
various screen sizes with different text sizing.
*/
import React from 'react';
import { styles } from './flexible-text-styles';

const FlexibleText = ({ children }): JSX.Element => {
  const classes = styles();
  return (
    <div className={classes.flexibleText}>
      <svg viewBox='0 0 60 60'>
        <text
          x='0'
          y='33'
          textLength='100%'
          lengthAdjust='spacingAndGlyphs'
          dominantBaseline='middle'
        >
          {children}
        </text>
      </svg>
    </div>
  );
};

export default FlexibleText;
